<template>
	<div class="totalinfo">
		<a-tag color="blue" style="text-align:left">
			<span  style="font-size:15px;padding:5px;display:inline-block"><strong>本页：</strong>总金额：{{sumdata.pagesum.num}} 元</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">未拨款：{{sumdata.pagesum.num0}} 元</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">已拨款：{{sumdata.pagesum.num1}} 元</span> 
			<br/>
			<span  style="font-size:15px;padding:5px;display:inline-block"><strong>总计：</strong>总金额：{{sumdata.pricesum}} 元</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">未拨款：{{sumdata.pricesum0}} 元</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">已拨款：{{sumdata.pricesum1}} 元</span> 
		</a-tag>
		<a-tag color="blue" style="text-align:left">
			<span  style="font-size:15px;padding:5px;display:inline-block"><strong>本页：</strong> 总人数：{{sumdata.pagesum.people}} 人</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">在场：{{sumdata.pagesum.people0}} 人</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">离场：{{sumdata.pagesum.people1}} 人</span> 
			<br/>
			<span  style="font-size:15px;padding:5px;display:inline-block"><strong>总计：</strong> 总人数：{{sumdata.peoplenum}} 人</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">在场：{{sumdata.peoplenum0}} 人</span> 
			<span  style="font-size:15px;padding:5px;display:inline-block">离场：{{sumdata.peoplenum1}} 人</span> 
		</a-tag>
    </div>
</template>

<script>
export default {
	props:["sumdata"]
}
</script>
